import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService } from '../core/core.service';
import { AuthService } from '../../services/auth/auth.service';
import { menuItems } from './home.config';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  constructor(private router: Router, private authService: AuthService) {}

  token$ = this.authService.token$;

  onButtonClick(item: any) {
    this.router.navigate([item.routerLink]);
  }

  isTileButtonVisible(item: any): boolean {
    return this.authService.hasRoles(item.roles);
  }

  getMenuItems() {
    return menuItems;
  }

}
